import { CurrentStreak } from "components";

import { useAppSelector } from "store/hooks";
import { selectUserAddressing, selectUserName } from "store/slices/user";
import { useWeeksCount } from "utils/hooks/useWeeksCount";

const WelcomeMessage = () => {
  const userVocativeName = useAppSelector(selectUserAddressing);
  const userName = useAppSelector(selectUserName);
  const { weeksCount } = useWeeksCount();

  const name = userVocativeName ?? userName;

  return (
    <>
      <div className="page-title__heading">
        <h1 className="mb-28px">
          Ahoj <span className={"text-highlight text-highlight--subtle"}>{name},</span>
        </h1>
        <div className="d-none d-md-block">
          <CurrentStreak />
        </div>
      </div>
      <p className="fw-bold">
        je před námi {weeksCount} týdnů do zkoušek a kromě testů nanečisto je třeba se naučit mezi nimi pravidelně
        procvičovat.
      </p>
    </>
  );
};

export default WelcomeMessage;
